module.exports = __webpack_public_path__ + "img/bot-avatar.d7f1bd5a.png";